import { Card, Stack, Typography, useTheme } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { organizationApi } from 'src/api/organization';
import OrganizationUsersListTable from 'src/sections/@dashboard/organization/components/OrganizationDetails/OrganizationUsers/OrganizationUsersListTable';
import { translateKey } from 'src/locales/translate';


export default function OrganizationDetailsUsersTabsPage() {
  const theme = useTheme();
  const { organizationId } = useParams();
  const { data, isError, isLoading } = useQuery(
    ['organization-users', organizationId],
    () =>
      organizationApi.organizationControllerGetOrganizationUsers({
        id: organizationId!,
      }),
    {
      retry: 2,
    },
  );
  const users = data?.data || [];

  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flex: 1,
        boxShadow: theme.customShadows.z24,
      }}
    >
      <Stack sx={{ height: 1, minHeight: '560px', flex: 1 }}>
        <Stack
          sx={{ minHeight: '84px' }}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          p={3}
        >
          <Typography variant="h6">{translateKey("hardcoded.uzytkownicy")}</Typography>
        </Stack>
        <OrganizationUsersListTable
          users={users}
          isError={isError}
          isLoading={isLoading}
        />
      </Stack>
    </Card>
  );
}
